import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-[#0f0a1a] text-gray-300">
      <div className="max-w-3xl mx-auto px-6 py-16">
        <Link to="/" className="inline-flex items-center gap-2 text-pink-400 hover:text-pink-300 mb-8" data-testid="terms-back-link">
          <ArrowLeft className="w-4 h-4" /> Back to Home
        </Link>
        <h1 className="text-3xl font-bold text-white mb-2">Terms of Service</h1>
        <p className="text-gray-500 text-sm mb-8">Last updated: January 1, 2025</p>

        <div className="space-y-6 leading-relaxed text-sm">
          <section>
            <h2 className="text-lg font-semibold text-white mb-2">1. Acceptance of Terms</h2>
            <p>By accessing and using this website, you agree to be bound by these Terms of Service. If you do not agree with any part of these terms, you must not use this website.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">2. Use of Services</h2>
            <p>Our website provides access to spiritual courses, books, and educational content. You agree to use these services only for lawful purposes and in accordance with these terms.</p>
            <ul className="list-disc list-inside mt-2 space-y-1 text-gray-400">
              <li>You must be at least 18 years old to make purchases.</li>
              <li>You are responsible for maintaining the confidentiality of your account.</li>
              <li>You agree not to reproduce, distribute, or share purchased content without authorization.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">3. Digital Products</h2>
            <p>Books and courses purchased through our platform are licensed for personal use only. You may not redistribute, resell, or share access to digital products. Secure PDF viewing is provided to protect intellectual property.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">4. Payments</h2>
            <p>All payments are processed securely through Stripe. Prices are listed in USD. By completing a purchase, you authorize us to charge your selected payment method for the total amount.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">5. Intellectual Property</h2>
            <p>All content on this website, including text, images, videos, courses, and books, is the intellectual property of Dr. Nawwaf Alshibli and is protected by copyright laws. Unauthorized use is strictly prohibited.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">6. Limitation of Liability</h2>
            <p>We provide our services on an "as is" basis. We are not liable for any indirect, incidental, or consequential damages arising from your use of the website or its content.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">7. Changes to Terms</h2>
            <p>We reserve the right to modify these terms at any time. Continued use of the website after changes constitutes acceptance of the new terms.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">8. Contact</h2>
            <p>For questions regarding these terms, contact us via WhatsApp at <a href="https://wa.me/963988242654" className="text-green-400 hover:text-green-300">+963 988 242 654</a>.</p>
          </section>
        </div>
      </div>
    </div>
  );
}
